export function formatDate(date) {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
}

function formatLicenseType(type) {
  switch (type) {
    case 0:
      return "recurring";
    default:
      return "unknown";
  }
}

export function formatContracts(contracts) {
  contracts.forEach((contract) => {
    contract.agreement_creation_date = formatDate(
      contract.agreement_creation_date
    );
    contract.agreement_type = formatLicenseType(contract.agreement_type);
    contract.numberOfAvaiableLicenses =
      contract.number_of_licenses_allowed - contract.licenses.length;

    if (contract.numberOfAvaiableLicenses < 0) {
      contract.numberOfAvaiableLicenses = 0;
    }
  });

  return contracts;
}
